import { t, UUID, DateTimeISO } from '../common.ts';

export const MonitorSeverity = t.Union([t.Literal('info'), t.Literal('warn'), t.Literal('critical')]);

export const MonitorAlertView = t.Object(
  {
    id: UUID,
    kind: t.Union([
      t.Literal('big_win'),
      t.Literal('big_loss'),
      t.Literal('abnormal_bet'),
      t.Literal('multi_account'),
      t.Literal('velocity_deposit'),
      t.Literal('velocity_withdraw'),
      t.Literal('bonus_abuse'),
      t.Literal('ip_blacklist'),
      t.Literal('device_blacklist'),
      t.Literal('provider_down'),
    ]),
    severity: MonitorSeverity,
    subjectKind: t.Union([
      t.Literal('member'),
      t.Literal('partner'),
      t.Literal('ip'),
      t.Literal('device'),
      t.Literal('provider'),
      t.Literal('system'),
    ]),
    subjectId: t.String(),
    summary: t.String(),
    detail: t.Record(t.String(), t.Unknown()),
    acknowledgedBy: t.Union([UUID, t.Null()]),
    acknowledgedAt: t.Union([DateTimeISO, t.Null()]),
    createdAt: DateTimeISO,
  },
  { $id: 'MonitorAlertView' },
);

export const OnlineUserView = t.Object(
  {
    memberId: UUID,
    username: t.String(),
    ipAddress: t.String(),
    connectedAt: DateTimeISO,
    lastActivityAt: DateTimeISO,
    deviceFingerprint: t.Union([t.String(), t.Null()]),
  },
  { $id: 'OnlineUserView' },
);

export const MultiAccountClusterView = t.Object(
  {
    id: UUID,
    clusterKey: t.String(),
    /**
     * The two the clustering can produce. `buildClusterCandidates` groups the
     * presence snapshot by IP and by device fingerprint; `same_bank`,
     * `same_canvas` and `same_webgl` were declared here and never written by
     * anything, which is what put three dead options in the backoffice filter
     * (#559 item 2). A new detector adds its literal here AND a producer.
     */
    reason: t.Union([t.Literal('same_ip'), t.Literal('same_device')]),
    memberIds: t.Array(UUID),
    firstSeenAt: DateTimeISO,
    lastSeenAt: DateTimeISO,
    resolved: t.Boolean(),
  },
  { $id: 'MultiAccountClusterView' },
);
